/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Research_Point_3Inputs */

const en_services_svc_research_point_3 = /** @type {(inputs: Services_Svc_Research_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Briefs and reports in the format your team uses`)
};

const lv_services_svc_research_point_3 = /** @type {(inputs: Services_Svc_Research_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopsavilkumi un atskaites komandai ierastā formātā`)
};

/**
* | output |
* | --- |
* | "Briefs and reports in the format your team uses" |
*
* @param {Services_Svc_Research_Point_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_research_point_3 = /** @type {((inputs?: Services_Svc_Research_Point_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Research_Point_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_research_point_3(inputs)
	return en_services_svc_research_point_3(inputs)
});